import { render, staticRenderFns } from "./MiniLoginWidget.vue?vue&type=template&id=c4ab1fb4&"
import script from "./MiniLoginWidget.vue?vue&type=script&lang=js&"
export * from "./MiniLoginWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports